/* eslint-disable max-len */
import { Plugins } from '@leverege/plugin';
import StringContainsComparator from './StringContainsComparator.js';
import StringContainsComparatorEditor from "./StringContainsComparatorEditor.js";
import StringContainsComparatorEvaluator from './StringContainsComparatorEvaluator.js';
import StringEndsWithComparator from './StringEndsWithComparator.js';
import StringEndsWithComparatorEditor from "./StringEndsWithComparatorEditor.js";
import StringEndsWithComparatorEvaluator from './StringEndsWithComparatorEvaluator.js';
import StringEqualsComparator from './StringEqualsComparator.js';
import StringEqualsComparatorEditor from "./StringEqualsComparatorEditor.js";
import StringEqualsComparatorEvaluator from './StringEqualsComparatorEvaluator.js';
import StringNotEqualsComparator from './StringNotEqualsComparator.js';
import StringNotEqualsComparatorEditor from "./StringNotEqualsComparatorEditor.js";
import StringNotEqualsComparatorEvaluator from './StringNotEqualsComparatorEvaluator.js';
import StringStartsWithComparator from './StringStartsWithComparator.js';
import StringStartsWithComparatorEditor from "./StringStartsWithComparatorEditor.js";
import StringStartsWithComparatorEvaluator from './StringStartsWithComparatorEvaluator.js';
export default {
  install(opts) {
    Plugins.add('AttributeConditionComparator', StringEqualsComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: StringEqualsComparator.TYPE,
      editor: StringEqualsComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: StringEqualsComparator.TYPE,
      evaluator: StringEqualsComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', StringNotEqualsComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: StringNotEqualsComparator.TYPE,
      editor: StringNotEqualsComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: StringNotEqualsComparator.TYPE,
      evaluator: StringNotEqualsComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', StringEndsWithComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: StringEndsWithComparator.TYPE,
      editor: StringEndsWithComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: StringEndsWithComparator.TYPE,
      evaluator: StringEndsWithComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', StringStartsWithComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: StringStartsWithComparator.TYPE,
      editor: StringStartsWithComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: StringStartsWithComparator.TYPE,
      evaluator: StringStartsWithComparatorEvaluator
    });
    Plugins.add('AttributeConditionComparator', StringContainsComparator);
    Plugins.add('AttributeConditionComparatorEditor', {
      type: StringContainsComparator.TYPE,
      editor: StringContainsComparatorEditor
    });
    Plugins.add('ConditionEvaluator', {
      type: StringContainsComparator.TYPE,
      evaluator: StringContainsComparatorEvaluator
    });
  }
};